import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'

const apiUrl = `${urlPrefix}/attach`
//#region select数据源相关api
export const GetNewGuid = `${apiUrl}/GetNewGuid`
export const GetInfo = `${apiUrl}/GetInfo`
export const GetList = `${apiUrl}/GetList`
export const Delete = (id: number) => `${apiUrl}/remove/${id}`
//#endregion

export const emptyDynamicAttach: DynamicAttachData = {
    //#region AttachSetting
    SettingId: 0,
    AttachName: '',
    Required: false,
    Exts: '',
    Sequence: 0,
    Status: 0,
    Comments: '',
    //#endregion

    //#region AttachRelation
    Id: 0,
    ReferId: 0,
    TempGuid: '',
    //#endregion

    //#region AttachRelation
    AttachId: 0,
    FilePath: '',
    FileName: '',
    FileExt: '',
    FileSize: 0
    //#endregion
}
export interface DynamicAttachData {
    //#region AttachSetting
    SettingId: number
    AttachName: string
    Required: boolean
    Exts: string
    Sequence: number
    Status: number
    Comments: string
    //#endregion

    //#region AttachRelation
    Id: number
    ReferId: number
    TempGuid: string
    //#endregion

    //#region AttachRelation
    AttachId: number
    FilePath: string
    FileName: string
    FileExt: string
    FileSize: number
    //#endregion
}

export const emptyAttach: AttachInfo = {
    //#region AttachRelation
    Id: 0,
    TempGuid: '',
    Name: '',
    Ext: '',
    Path: '',
    SavePath: '',
    Size: 0,
    Comments: '',
    //#endregion
}
export interface AttachInfo {
    Id: number
    TempGuid: string
    Name: string
    Ext: string
    Path: string
    SavePath: string
    Size: number
    Comments: string
}
export const getNewGuid = () => {
    return tryAxios({
        method: 'get',
        url: GetNewGuid
    })
}
export const getInfo = (referId: number, referType: number, tempGuid: string) => {
    return tryAxios({
        method: 'get',
        url: GetInfo,
        params: {
            refId: referId,
            refType: referType,
            guid: tempGuid
        }
    })
}
export const getList = (referId: number, referType: number, tempGuid: string) => {
    return tryAxios({
        method: 'get',
        url: GetList,
        params: {
            refId: referId,
            refType: referType,
            guid: tempGuid
        }
    })
}
export const remove = (id: number) => {
    return tryAxios({
        method: 'post',
        url: Delete(id)
    })
}
//点击打开文件
export const openFile = (href: string, downloadName: string) => {
    // downloadName = encodeURIComponent(downloadName)
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = href
    link.setAttribute('download', downloadName)
    link.setAttribute('target', '_blank')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}